<template>
    <div class="app" v-cloak>
        <app-header />
        <transition name="fade" appear @after-leave="afterLeave" @after-appear="afterLeave">
            <router-view />
        </transition>
    </div>
</template>

<script>
//@ is an alias to /src
import AppHeader from '@/components/AppHeader.vue'
import deeplinking from '@/mixins/deeplinking'
import '@/helpers/filters'
//import scrollBehavior, { scrollBehaviorPositionProcessor } from './router/scrollBehavior'

// Fonts already available as we inject the app into the frontend
if (process.env.NODE_ENV !== 'production') {
    import('./assets/css/fonts.css')
}

export default {
    name: 'App',
    components: {
        AppHeader
    },
    mixins: [deeplinking],
    methods: {
        afterLeave () {
            this.$root.$emit('rootTransitionAfterLeave')
        }
    },
    mounted () {
        //scrollBehavior not working on first time page load
        //@see https://github.com/nuxt/nuxt.js/issues/4024
        /*if (!this.$route.hash) return
        this.$nextTick(() => {
            scrollBehavior(this.$route)
                .then(scrollBehaviorPositionProcessor)
                .then((position) => {
                    window.scrollTo(position.x, position.y)
                })
                .catch(() => {})
        })*/
    }
}
</script>

<style>
    @import './assets/css/custom-reboot.css';
    @import './assets/css/custom-bootstrap.css';
    @import '~bootstrap/dist/css/bootstrap-grid.css';
    @import './assets/css/magento-corrections.css';
    @import './assets/css/app.css';
    @import './assets/css/btn.css';
    @import './assets/css/app-view-footer.css';
    @import './assets/css/app-view-header.css';
</style>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
